const UPLOAD_NONE = 0, UPLOAD_FILE = 1, UPLOAD_URL = 2;

class GraphicEditor {
	static uploadFile(file, onComplete, initialName) {
		let editor = new GraphicEditor(onComplete);
		editor._upload = UPLOAD_FILE;
		editor._file = file;
		editor.addLayer(GraphicLayer.newWithFile(file));
		editor.name = initialName;
		editor._dialog.ready();
	}
	
	static uploadUrl(url, onComplete, initialName) {
		let editor = new GraphicEditor(onComplete);
		API.insert('graphics', {
			url: url
		})
		.then(reply => {
			if (reply.id) {
				editor.loadDetails(reply.id);
			}
			if (reply.error) {
				makeToast(reply.error);
				editor.dispose();
			}
			
		});
		editor.name = initialName;
		editor._dialog.loading();
	}
	
	static fromId(id, onComplete) {
		let editor = new GraphicEditor(onComplete);
		editor.loadDetails(id);
		return editor;
	}
	
	static newComp(onComplete) {
		let editor = new GraphicEditor(onComplete);
		editor.comp = true;
		editor._dialog.ready();
		return editor;
	}

	constructor(onComplete) {
		this._onComplete = typeof onComplete === 'undefined' ? null : onComplete;
		this._upload = UPLOAD_NONE;
		this._file = null;
		this._url = null;
		this._id;

		this.loadedLayers = 0;
		this._layers = [];
		this._activeLayer = 0;

		this._x = 0;
		this._y = 0;
		this._r = 0;
		this._s = 0;
		this._f = null;

		this.minScale = 0.1; 
		this.maxScale = 10;

		this._scaleFactor = Math.log(9.9);

		this._svg = document.createElementNS(xmlns, 'svg');

		this._sliderControl = new SliderControl();

		this._dialog = Dialog.Modal('adjust-graphic', _("Adjust graphic"), X_LARGE, _("SAVE"), UI.div(null, [
			UI.div('image-container', [
				this._imageContainer = UI.div(),
				this._svg,
				this._ctlArea = UI.div('image-controls', [
					this._cp0 = UI.div('rotate-control primary-color'),
					this._cp1 = UI.div('scale-control primary-color'),
					this._cp2 = UI.div('scale-control primary-color'),
					this._cp3 = UI.div('scale-control primary-color'),
					this._cp4 = UI.div('scale-control primary-color'),
				]),
				this.prg =htm('canvas', 'image-progress')
			]),
			this._controlContainer = UI.div('control-container', [
				// label(null, _("Flip")),
				// UI.div(null, [
				// 	this._flipH = btn('btn i-lg i-flip-h'),
				// 	this._flipV = btn('btn i-lg i-flip-v')
				// ]),
				UI.label(_("Scale")),
				UI.div(null, [
					this._sInput = UI.text(1)
				]),
				UI.label(_("Rotation")),
				UI.div(null, [
					this._rInput = UI.text(0)
				]),
				UI.div(null, [
					this._resetBtn = UI.btn('', _("RESET"), {
						'click': this.reset.bind(this)
					})
				])
			]),
			this._thumbContainer = UI.div('layer-thumbs', [
				UI.div(null, [
					this._addLayerBtn = UI.priIconBtn('plus-square', 22)
				])
			])
		]));
		this._dialog.foot = this._nameText = UI.text(_("New composition"));

	
		this._svg.appendChild(this._bl0 = document.createElementNS(xmlns, 'line'));
		this._bl0.setAttribute('stroke', AC.THEMES[userTheme].primary[600]);
		this._bl0.setAttribute('stroke-width', 2);
		this._svg.appendChild(this._bl1 = document.createElementNS(xmlns, 'line'));
		this._bl1.setAttribute('stroke', AC.THEMES[userTheme].primary[600]);
		this._bl1.setAttribute('stroke-width', 2);
		this._svg.appendChild(this._bl2 = document.createElementNS(xmlns, 'line'));
		this._bl2.setAttribute('stroke', AC.THEMES[userTheme].primary[600]);
		this._bl2.setAttribute('stroke-width', 2);
		this._svg.appendChild(this._bl3 = document.createElementNS(xmlns, 'line'));
		this._bl3.setAttribute('stroke', AC.THEMES[userTheme].primary[600]);
		this._bl3.setAttribute('stroke-width', 2);
		this._svg.appendChild(this._bl4 = document.createElementNS(xmlns, 'line'));
		this._bl4.setAttribute('stroke', AC.THEMES[userTheme].primary[600]);
		this._bl4.setAttribute('stroke-width', 2);


		onEv(document, 'layerLoaded', () => {
			this.loadedLayers++;
			if (this.loadedLayers == this._layers.length) this._dialog.ready();
		});
		
		onEv(this._imageContainer, 'mousedown touchstart', this.moveInit.bind(this));
		onEv(this._cp0, 'mousedown touchstart', this.rotateInit.bind(this));
		onEv(this._cp1, 'mousedown touchstart', this.initScale.bind(this, 1));
		onEv(this._cp2, 'mousedown touchstart', this.initScale.bind(this, 2));
		onEv(this._cp3, 'mousedown touchstart', this.initScale.bind(this, 3));
		onEv(this._cp4, 'mousedown touchstart', this.initScale.bind(this, 4));
		onEv(this._addLayerBtn, 'click', this.searchLayer.bind(this));

		onEv(this._sInput, 'mousedown touchstart', this.initScaleSlider.bind(this));
		onEv(this._rInput, 'mousedown touchstart', this.initRotateSlider.bind(this));
		onEv(this._sInput, 'keyup', (ev) => {
			switch (ev.keyCode) {
				case AC.ENTER_KEY:
					let scale = parseFloat(this._sInput.value);
					if (scale != null && !isNaN(scale)) {
						this._layers[this._activeLayer]._s = scale;
					}
				case AC.ESCAPE_KEY:
					this.update();
				default:
			}
			stopEv(ev);
		});

		onEv(this._rInput, 'keyup', (ev) => {
			switch (ev.keyCode) {
				case AC.ENTER_KEY:
					let rotation = parseInt(this._rInput.value);
					if (rotation != null && !isNaN(rotation)) {
						while (rotation > 180) rotation -= 360;
						while (rotation < -180) rotation += 360;
						this._layers[this._activeLayer]._r = rotation;
					}
				case AC.ESCAPE_KEY:
					this.update();
				default:
			}
			stopEv(ev);
		});

		this.selectLayer = this.selectLayer.bind(this);
		this.remLayer = this.remLayer.bind(this);
		this.moveUp = this.moveUp.bind(this);
		this.moveDn = this.moveDn.bind(this);
		onEv(document, 'layerSelect', this.selectLayer);
		onEv(document, 'layerRemove', this.remLayer);
		onEv(document, 'layerUp', this.moveUp);
		onEv(document, 'layerDn', this.moveDn);
		
		this.comp = false;
		// this.progress(0);
		
		this._dialog.open(this.done.bind(this), this.dispose.bind(this), false).loading();
	}

	get active() {
		if (this._activeLayer === -1 || this._layers.length === 0) return null;
		return this._layers[this._activeLayer];
	}
	
	set name(value) {
		this._nameText.value = value;
		this._nameText.select();
	}
	
	set comp(value) {
		this._comp = value;
		this._thumbContainer.style.display = this._comp ? 'block' : 'none';
	}

	dispose() {
		this._dialog.close();
		this._dialog.dispose();
		this._sliderControl.dispose();
		remEv(document, 'layerSelect', this.selectLayer);
		remEv(document, 'layerRemove', this.remLayer);
		remEv(document, 'layerUp', this.moveUp);
		remEv(document, 'layerDn', this.moveDn);
	}

	selectLayer(ev) {
		this._activeLayer = ev.detail - 1;
		this.update();
	}

	loadDetails(id) {
		this._id = id;
		
		API.fetch('graphics/' + this._id)
		.then(json => {
			this.comp = !!json.comp;
			if (json.layers && Array.isArray(json.layers)) {
				for(let data of json.layers) {
					this.addLayer(GraphicLayer.fromArray(data));
				}
			}
			if (json.name) this.name = json.name;
			this.updateControls();
		});
	}
	
	done() {
		if (this._upload) this.upload();
		else this.save();
	}
	
	upload() {
		this.updateControls();
		let fd = new FormData();
		let json = this.data();
		if (this._upload == UPLOAD_FILE) {
			fd.append('file', this._file);
		}
		else if (this._upload == UPLOAD_URL) {
			json.url = this._url;
		}
		fd.append('json', JSON.stringify(json));
		
		this.xhr = new XMLHttpRequest();
		this.xhr.open('POST',API.path('graphics'));
		
		this.xhr.onreadystatechange = () => {
			if (this.xhr.readyState === 4 && this.xhr.status === 200) {
				let data = JSON.parse(this.xhr.responseText);
				this.dispose();
				makeToast(_("File uploaded"));
				if (this._onComplete !== null) this._onComplete(data.id);
				else document.dispatchEvent(new Event('primaryDataInvalid'));
			}
		}
		
		this.xhr.upload.addEventListener(
			"progress",
			(e) => {
				if (e.loaded && e.total) {
					this.progress(Math.round((e.loaded * 100) / e.total));
				}
			},
			false
		);
		
		this.xhr.upload.addEventListener(
			"load",
			() => {
				this.progress(100);
			}
		)
		
		this.xhr.send(fd);
	}
	
	progress(value) {
		this.prg.style.display = value > 0 ? 'block' : 'none';
		let ctx = this.prg.getContext('2d');
		ctx.fillStyle = value == 100 ? 'green' : 'orange';
		ctx.fillRect (
			0,
			0,
			this.prg.offsetWidth * value / 100,
			40
		);
	}

	save() {
		API.upsert('graphics', this._id, this.data())
		.then(() => {
			this.dispose();
			// makeToast(_("File uploaded"));
			if (this._onComplete !== null) this._onComplete(this._id);
			else document.dispatchEvent(new Event('primaryDataInvalid'));
		})
	}
	
	data() {
		let layerData = [];
		this._layers.forEach(layer => {
			layerData.push(
				layer.map()
			);
		});
		return {
			name: this._nameText.value,
			comp: this._comp,
			layerData: layerData
		}
	}
	
	reset() {
		this.active.fit();
		this.snapshot();
		this.update();
	}
	
	clicked() {
		this.update();
	}

	dropped() {
		this.snapshot();
	}

	snapshot(controlPoint) {
		if (this.active === null) return;
		this._o = this.active.center();
		this._x = this.active._x;
		this._y = this.active._y;
		this._s = this.active._s;
		this._r = this.active._r;

		if (typeof(controlPoint) === 'undefined') return;
		this._sx = controlPoint.offsetLeft - this._o.x;
		this._sy = controlPoint.offsetTop - this._o.y;
		this._sr = cart2polar(this._sx, this._sy).r;
	}

	moveInit(ev) {
		let newLayer = null;
		for (let i = 0, ii = this._layers.length; i < ii; i++) {
			if (this._layers[i].hit(ev)) {
				newLayer = i;
				break;
			}
		}
		if (newLayer !== null) this._activeLayer = newLayer;
		this.snapshot();
		this.drag = this.move;
		startDrag(ev, this);
	}

	move() {
		this.active._x = this._x + dx;
		this.active._y = this._y + dy;
		this.update();
	}


	rotateInit(ev) {
		this.snapshot(this._cp0);
		this.drag = this.rotate;
		startDrag(ev, this);
	}
	
	rotate(){
		this.active._r = cart2polar(this._sx + dx, this._sy + dy).a + 90;
		this.update();
	}

	initRotateSlider() {
		if (this.active === null) return;
		this.snapshot();
		this._sliderControl.value = this.rotation2value(this.active._r);
		this._sliderControl.show(
			this._rInput, 
			this.rotateBySlider.bind(this),
			this.dropped.bind(this)
		);
	}

	rotateBySlider(value) {
		this.active._r = this.value2rotation(value);

		let po = cart2polar(this._o.x - 200, this._o.y - 200);
		let co = polar2cart(po.r, po.a + this.active._r - this._r);
		this.active._x = this._x - this._o.x + co.x + 200;
		this.active._y = this._y - this._o.y + co.y + 200;
		this.update();
	}

	rotation2value(input) {
		return (input / 360) + 0.5;
	}

	value2rotation(input) {
		return (input - 0.5) * 360;
	}

	initScale(controlPoint, ev) {
		switch (controlPoint) {
			case 1: this.snapshot(this._cp1); break;
			case 2: this.snapshot(this._cp2); break;
			case 3: this.snapshot(this._cp3); break;
			case 4: this.snapshot(this._cp4); break;
			default: return;
		}
		
		this.snapshot();
		this.drag = this.scale;
		startDrag(ev, this);
	}

	scale() {
		let radius = cart2polar(this._sx + dx, this._sy + dy).r;
		this.active._s = (this._s / this._sr) * radius;
		this.active._x = (((this._x - this._o.x) / this._s) * this.active._s) + this._o.x;
		this.active._y = (((this._y - this._o.y) / this._s) * this.active._s) + this._o.y;
		this.update();
	}

	initScaleSlider() {
		if (this.active === null) return;
		this.snapshot();
		this._sliderControl.value = this.scale2value(this._s);
		this._sliderControl.show(
			this._sInput, 
			this.scaleBySlider.bind(this),
			this.dropped.bind(this)
		);
	}

	scaleBySlider(value) {
		this.active._s = this.value2scale(value);
		// this.active._x = (((this._x - this._o.x) / this._s) * this.active._s) + this._o.x;
		// this.active._y = (((this._y - this._o.y) / this._s) * this.active._s) + this._o.y;
		this.active._x = (((this._x - 200) / this._s) * this.active._s) + 200;
		this.active._y = (((this._y - 200) / this._s) * this.active._s) + 200;
		this.update();
	}

	value2scale(input) {
		return Math.pow(input * Math.E, this._scaleFactor) + this.minScale;
	}

	scale2value(input) {
		return Math.pow(input - this.minScale, 1 / this._scaleFactor) / Math.E;
	}

	update() {
		this.active.update();
		this.updateControls();
	}

	translateControlPoint(point, origin) {
		let polar = cart2polar(point.x - origin.x, point.y - origin.y);
		let cart = polar2cart(polar.r, polar.a + this.active._r);
		return {
			'x': cart.x + origin.x,
			'y': cart.y + origin.y
		};
	}

	setLine(obj,x1,x2,y1,y2) {
		obj.setAttribute('x1', x1);
		obj.setAttribute('x2', x2);
		obj.setAttribute('y1', y1);
		obj.setAttribute('y2', y2);
	}

	updateControls() {
		if (this.active === null) return;

		this._sInput.value = this.active._s.toFixed(3);
		this._rInput.value = this.active._r.toFixed(0);

		if (!this.active.loaded) return;

		let p1, p2;
		let o = this.active.center();
		p1 = this.translateControlPoint({
			'x': o.x,
			'y': o.y - (this.active.h / 2)
		}, o);
		p2 = this.translateControlPoint({
			'x': o.x,
			'y': o.y - (this.active.h / 2) - 40
		}, o);
		this.setLine(this._bl0, p1.x, p2.x, p1.y, p2.y);
		this._cp0.style.left = p2.x + 'px';
		this._cp0.style.top = p2.y + 'px';
		p1 = this.translateControlPoint({
			'x': o.x - (this.active.w / 2),
			'y': o.y - (this.active.h / 2)
		}, o);
		p2 = this.translateControlPoint({
			'x': o.x + (this.active.w / 2),
			'y': o.y - (this.active.h / 2)
		}, o);
		this.setLine(this._bl1, p1.x, p2.x, p1.y, p2.y);
		this._cp1.style.left = p1.x + 'px';
		this._cp1.style.top = p1.y + 'px';
		this._cp1.style.transform = 'rotate(' + this.active._r + 'deg)';
		p1 = p2;
		p2 = this.translateControlPoint({
			'x': o.x + (this.active.w / 2),
			'y': o.y + (this.active.h / 2)
		}, o);
		this.setLine(this._bl2, p1.x, p2.x, p1.y, p2.y);
		this._cp2.style.left = p1.x + 'px';
		this._cp2.style.top = p1.y + 'px';
		this._cp2.style.transform = 'rotate(' + this.active._r + 'deg)';
		p1 = p2;
		p2 = this.translateControlPoint({
			'x': o.x - (this.active.w / 2),
			'y': o.y + (this.active.h / 2)
		}, o);
		this.setLine(this._bl3, p1.x, p2.x, p1.y, p2.y);
		this._cp3.style.left = p1.x + 'px';
		this._cp3.style.top = p1.y + 'px';
		this._cp3.style.transform = 'rotate(' + this.active._r + 'deg)';
		p1 = p2;
		p2 = this.translateControlPoint({
			'x': o.x - (this.active.w / 2),
			'y': o.y - (this.active.h / 2)
		}, o);
		this.setLine(this._bl4, p1.x, p2.x, p1.y, p2.y);
		this._cp4.style.left = p1.x + 'px';
		this._cp4.style.top = p1.y + 'px';
		this._cp4.style.transform = 'rotate(' + this.active._r + 'deg)';
	}

	searchLayer(graphicId) {
		if (typeof(graphicId) === 'object'){
			gSearch.start('', this.searchLayer.bind(this));
		}
		else {
			this.addLayer(GraphicLayer.newWithId(graphicId));
		}
	}

	addLayer(layer) {
		this._layers.unshift(layer); 
		this._activeLayer = 0;
		if (this._comp) this._thumbContainer.insertBefore(layer.thumbTile, this._thumbContainer.childNodes[1]);
		this.reorder();
	}

	remLayer(ev) {
		let i = ev.detail;
		this._thumbContainer.removeChild(this._thumbContainer.childNodes[i]);
		this._layers.splice(i-1, 1);
		this.reorder();
	}

	moveUp(ev) {
		let i = ev.detail;
		if (i == 1) return;
		let len = this._thumbContainer.childNodes.length;
		this._thumbContainer.insertBefore(this._thumbContainer.childNodes[i], this._thumbContainer.childNodes[i - 1]);
		i--;
		// this._imageContainer.insertBefore(this._imageContainer.childNodes[i], this._imageContainer.childNodes[i - 1]);
		this._layers.splice(i - 1, 0, this._layers.splice(i, 1)[0]);
		this.reorder();
	}

	moveDn(ev) {
		let i = ev.detail;
		if (i == this._layers.length) return;
		this._thumbContainer.insertBefore(this._thumbContainer.childNodes[i], this._thumbContainer.childNodes[i + 2]);
		i--;
		// this._imageContainer.insertBefore(this._imageContainer.childNodes[i], this._imageContainer.childNodes[i + 2]);
		this._layers.splice(i + 1, 0, this._layers.splice(i, 1)[0]);
		this.reorder();
	}

	reorder() {
		for (let i = 0, ii = this._layers.length; i < ii; i++) {
			this._layers[i].order = i + 1;
		}
		this._imageContainer.innerHTML = '';
		this._layers.forEach((layer) => this._imageContainer.insertBefore(layer._canvas, this._imageContainer.firstChild));
	}
}